import { Flex, GridItem, GridLayout, Icon, Typography } from '@nilohealth/core-ui'
import { MdBarChart } from 'react-icons/md'

import { NavbarContainer, NavbarDivider } from '@navbar/navbar.styles'

import NavbarList from './navbar-list'
import NavbarMenu from './navbar-menu'
import NavbarProfile from './navbar-profile'

const Navbar = () => {
  return (
    <NavbarContainer>
      <GridLayout alignItems="center">
        <GridItem
          css={{
            alignSelf: 'center',
            '@sm': { gridColumn: 'span 3' },
            '@md': { gridColumn: 'span 9' },
            '@lg': { gridColumn: 'span 9' },
          }}
        >
          <Flex align="center" gap="xxxsmall">
            <NavbarMenu />
            <Flex align="center" gap="nano">
              <Icon icon={MdBarChart} color="primaryMedium" size="medium" />

              <Typography type="subtitleSmall" weight="regular">
                Compass
              </Typography>
            </Flex>

            <NavbarDivider />

            <NavbarList />
          </Flex>
        </GridItem>

        <GridItem
          css={{
            justifySelf: 'end',
            alignSelf: 'center',
            '@sm': { gridColumn: '-2 / span 1' },
            '@md': { gridColumn: '-4 / span 3' },
            '@lg': { gridColumn: '-4 / span 3' },
          }}
        >
          <NavbarProfile />
        </GridItem>
      </GridLayout>
    </NavbarContainer>
  )
}

export default Navbar
